import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * 現場常駐社員・非常駐入退場者一覧取得API
 * @param {string}fieldId: 現場ID
 * @param {object}param
 * */
const fetchFieldSpotWorkersList = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_spot_workers/list`),
    params: param,
  });
};

export const FieldSpotWorkersApi = {
  fetchFieldSpotWorkersList,
};

export default FieldSpotWorkersApi;



// WEBPACK FOOTER //
// ./src/services/fieldSpotWorkers/FieldSpotWorkersApi.js